import styled from 'styled-components';
import { verticalGutter } from '../../styles';

export const FlexTileContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: 100%;
`;

export const StyledInfoTile = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${verticalGutter * 0.8}rem;
  max-width: 364px; /* According to latest designs */

  .select {
    width: 100%;
    margin-right: ${verticalGutter / 2}rem;
  }

  /* for CTAs */
  .button {
    display: flex;
    justify-content: center;
  }

  label {
    position: absolute;
    overflow: hidden;
    width: 1px;
    height: 1px;
    right: 100vw;
  }
`;
